let env = {};

env.baseURL = 'https://api.4820606.it4d.com.br/api/v1/';
env.normalURL = 'https://api.4820606.it4d.com.br/';
env.webserviceHost = 'websocket.6146341.it4d.com.br';
env.webservicePort = '443';
env.pusherKey = '4820606-key',
env.painelInatividade = 5;
env.mode = 'production';

// env.baseURL = 'https://api.dev-sigap.it4d.com.br/api/v1/';
// env.normalURL = 'https://api.dev-sigap.it4d.com.br/';

// env.baseURL = 'http://localhost:8000/api/v1/';
// env.normalURL = 'http://localhost:8000/';

// env.mode = 'homolog';
// env.mode = 'production';
// env.mode = 'development';

export default env
